<template>
  <div>
    <div class="col-12">
      <div class="d-flex justify-content-end pb-3">
        <b-button
          variant="primary"
          @click="rejectModalOpen"
        >
          {{$t('modal.nameModalPost')}}
        </b-button>
      </div>
    </div>

    <div class="col-12">
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
        >
          <template #cell(status)="{item}">
            <span v-if="item.status === 3">
              {{$t('messageStatus.driverManageIncomesStatus4')}}
            </span>

            <span v-if="item.status === 4">
              {{$t('messageStatus.driverManageIncomesStatus5')}}
            </span>

            <span v-if="item.status === 5">
              {{$t('messageStatus.driverManageIncomesStatus6')}}
            </span>
          </template>
          <!-- <template #cell(actions)>
            <b-button
              variant="success"
              size="sm"
            >
              <i class="bx bx-pen fs-4"></i>
            </b-button>
          </template> -->
        </b-table>
      </div>
    </div>

    <b-modal
      v-model="rejectModalBool"
      hide-header
      hide-footer
    >
      <RejectModal 
        :productsOptions="productsOptions"
        :managerOptions="managerOptions"
        @onClose="rejectModalClose"
      />
    </b-modal>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {getInfoAll} from '../../../api/endpoints/products';
  import RejectModal from './components/rejectModal.vue'
  import {driverIndex} from '../../../api/endpoints/driverMoneyManagement'


  export default {
    name: "Driver-ManageIncomes",
    components: {
      RejectModal
    },
    data() {
      return {
        rejectModalBool: false,
        fields: [
          {key: "id", label: "№"},
          {key: "date", label: this.$t('table.date')},
          {key: "product.name", label: this.$t('table.product.label')},
          {key: "quantity", label: this.$t('table.quantity.label')},
          {key: "status", label: this.$t('table.status.label')},
          // {key: "actions", label: this.$t('table.actions.label')}
        ],
        productsOptions: [],
        managerOptions: [],
      }
    },
    mounted() {
      this.fetchData();
      this.getProductOptions();
      this.getManagerOption();
    },
    methods: {
      ...mapActions('driversManageIncomes', ['fetchData']),
      rejectModalOpen() {
        this.rejectModalBool = true;
      },
      rejectModalClose() {
        this.rejectModalBool = false;
        this.fetchData();
      },
      getProductOptions() {
        getInfoAll().then( res => {
          this.productsOptions = res.data.data.map(item => Object.assign( {}, {value: item.id, label: item.name}))
        })
      },
      getManagerOption() {
        driverIndex({manager: true}).then( res => {
          this.managerOptions = res.data.data.map( item => Object.assign({}, {value: item.id, label: item.full_name}))
        })
      }
    },
    computed: {
      ...mapGetters('driversManageIncomes', ['items'])
    }
  }
</script>